import {change_admin, change_loading, set_user_id} from "../reducers/main_reducer";
import {BX24} from "../../hooks/BX24";

export const ThunkCheckDepartment = () => {
    return async (dispatch) => {

        dispatch(change_loading(true))

        const user = await BX24('user.current')
        console.log(user)
        const admin = await user.result.UF_DEPARTMENT[0]
        if(admin === 52 /*|| admin === 60*/ || admin === 66)
            dispatch(change_admin(true))

        dispatch(set_user_id(user.result.ID))
        dispatch(set_user_id(user.result.ID))

        dispatch(change_loading(false))
    }
}